import dayjs from "dayjs";
import {
  AGENT_ANNOTATION,
  AGENT_TOOL_ANNOTATION,
  CONTENT_ANNOTATION,
  CAMPAIGN_ANNOTATION,
  EMAIL_ANNOTATION,
  FOLDER_TYPE,
  FORM_ANNOTATION,
  PORTAL_ANNOTATION,
  PROJECT_ANNOTATION,
  PUBLISHED,
  SEQUENCE_ANNOTATION,
  SHEET_ANNOTATION,
  WORKFLOW_ANNOTATION,
} from "../constants/common-constants";

export const getInitials = (value, seperator = " ", capitalize = true) => {
  if (!value) return "";
  return value
    .split(seperator)
    .map((x) => {
      const _value = x.substr(0, 1);
      if (capitalize) {
        return _value.toUpperCase();
      }
      return _value;
    })
    .join("");
};

export const getAssetIcon = (asset) => {
  if (
    asset?.annotation === WORKFLOW_ANNOTATION ||
    asset?.annotation === AGENT_TOOL_ANNOTATION
  ) {
    return "TINYWorkflowIcon";
  } else if (asset?.annotation === FORM_ANNOTATION) {
    return "TINYFormIcon";
  } else if (asset?.annotation === SHEET_ANNOTATION) {
    return "TINYSheetIcon";
  } else if (asset?.annotation === CONTENT_ANNOTATION) {
    return "WCContentIcon";
  } else if (asset.type === FOLDER_TYPE) {
    // Projects are folders under the hood, but distinct concepts — give them their own icon so they
    // never read as a plain folder in any list (Home, My Files, Search, All Assets).
    return asset?.annotation === PROJECT_ANNOTATION
      ? "OUTELayersIcon"
      : "WCFolderIcon";
  } else if (asset?.annotation === EMAIL_ANNOTATION) {
    return "TINYMailIcon";
  } else if (asset?.annotation === AGENT_ANNOTATION) {
    return "TinyAgentLogo";
  } else if (asset?.annotation === SEQUENCE_ANNOTATION) {
    return "BrandSequenceIcon";
  } else if (asset?.annotation === PORTAL_ANNOTATION) {
    return "PortalIcon";
  } else if (asset?.annotation === CAMPAIGN_ANNOTATION) {
    return "OUTEAnnouncementIcon";
  }
};

export const formatIsoDateToCustom = (isoDate, dateFormat) => {
  if (!isoDate) return "";
  return dayjs(isoDate).format(dateFormat);
};

export const formatSubmissionTime = (timeInMs) => {
  console.log("timeInMs", timeInMs);
  if (!timeInMs || timeInMs === 0) return "-";
  const totalSeconds = Math.floor(timeInMs / 1000);

  if (totalSeconds < 60) {
    return "Less than 1 minute";
  }

  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  // Less than 1 hour: show minutes and seconds
  if (totalMinutes < 60) {
    if (seconds === 0) {
      return `${totalMinutes} ${totalMinutes === 1 ? "minute" : "minutes"}`;
    }
    return `${totalMinutes} ${
      totalMinutes === 1 ? "minute" : "minutes"
    }, ${seconds} ${seconds === 1 ? "second" : "seconds"}`;
  }

  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Less than 24 hours: show hours, minutes, and seconds
  if (totalHours < 24) {
    const parts = [];
    parts.push(`${totalHours} ${totalHours === 1 ? "hour" : "hours"}`);
    if (minutes > 0) {
      parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
    }
    if (seconds > 0) {
      parts.push(`${seconds} ${seconds === 1 ? "second" : "seconds"}`);
    }
    return parts.join(", ");
  }

  // 24 hours or more: show days, hours, and minutes
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const parts = [];
  parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
  }
  return parts.join(", ");
};

export const checkIsPublished = (item) => {
  if (item?.publish_status !== undefined) {
    return item.publish_status === PUBLISHED;
  }
  return !!item?.published_info?.published_at;
};
